import React, { Fragment } from 'react';
import Select from 'react-select';
import {
  Form,
  FormGroup,
  Button,
  Row,
  Col,
  Label,
  Input,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import WithAlert from '../../../../hoc/WithAlert';
import Card from '../../../../components/Card/Card';
import PaymentRules from '../../../../components/Finances/PaymentRules';
import Hold2BalanceOrder from '../../../../components/Finances/Hold2BalanceOrder';
import SMSNotificationsModal from '../../../../modals/SMSNotificationsModal/SMSNotificationsModal';
import PaymentOrderBadges from './PaymentOrderBadges';
import { currencyToSign } from '../../../../utils/utils';

const PaymentsOrdersForm = ({
  data: {
    errors,
    authType,
    data,
    rules,
    selectedCurrency,
    smsConfirmModalShow,
    loading,
    purses,
    currencies,
    sessionId,
    validTill,
    error,
    status,
    intl,
    isSlaveAndNotInMember,
    isUserBlocked,
    selected,
    balance,
    rates,
    toCurrency,
    isCurrencyConverting,
    transport,
  },
  onSubmit,
  onSelectCurrency,
  getFormattedMessage,
  onAmountChange,
  onToPayoutChange,
  getOptions,
  onSelectPurse,
  toggleModal,
  selectCurrenciesNoResultsText,
  selectNoResultsText,
  getCurrencyOptions,
  getTotal,
  showAlert,
  renderConverToCurrencyTooltip,
}) => {
  return (
    <Fragment>
      {balance && <PaymentOrderBadges balance={balance} />}

      {data.purse !== null && (
        <PaymentRules rules={rules} currency={toCurrency} intl={intl} purseId={data.purse} />
      )}
      <Card>
        <Card.Body>
          <Form className="finances-payments-form" onSubmit={onSubmit} autoComplete="off">
            <Row className="row-1">
              <Col xl="3" lg="6" md="12">
                <FormGroup>
                  <Label htmlFor="payments.currency">
                    <FormattedMessage id="payments.choose_currency" defaultMessage="Currency" />
                  </Label>
                  <Select
                    className={cn('purses-select Select--sm', { 'has-error': errors.purse })}
                    options={getCurrencyOptions(currencies)}
                    value={selectedCurrency}
                    onChange={onSelectCurrency}
                    placeholder={getFormattedMessage('payments.choose_currency', 'Currency')}
                    noResultsText={selectCurrenciesNoResultsText}
                    clearable={false}
                    multi={false}
                    tabIndex="1"
                    disabled={isUserBlocked}
                    id="payments.currency"
                  />
                </FormGroup>
              </Col>

              <Col xl="3" lg="6" md="12">
                <FormGroup>
                  <Label htmlFor="payments.purse">
                    <FormattedMessage id="payments.purse" defaultMessage="Purse" />
                  </Label>
                  <Select
                    className={cn('purses-select Select--sm', {
                      'has-error': errors.purse,
                    })}
                    options={getOptions(purses)}
                    value={selectedCurrency && data.purse}
                    onChange={onSelectPurse}
                    placeholder={getFormattedMessage('payments.choose_purse', 'Pay on...')}
                    disabled={selectedCurrency === null}
                    noResultsText={selectNoResultsText}
                    clearable={false}
                    multi={false}
                    tabIndex="3"
                    id="payments.purse"
                  />
                </FormGroup>
              </Col>

              <Col xl="3" lg="6" md="12" className="payments-amount">
                <FormGroup className={cn({ 'has-error': errors.amount })}>
                  <Label htmlFor="payments.amount">
                    <FormattedMessage id="payments.amount.label" defaultMessage="Payments amount" />
                  </Label>
                  <Input
                    bsSize="sm"
                    value={data.amount === 0 ? '' : data.amount}
                    onChange={(e) =>
                      onAmountChange(
                        e.target.value,
                        rules,
                        selectedCurrency,
                        toCurrency,
                        rates,
                        data.purse,
                      )
                    }
                    maxLength="12"
                    tabIndex="2"
                    disabled={isUserBlocked}
                    id="payments.amount"
                  />
                  {errors.amount && <small className="form-text">{errors.amount}</small>}
                </FormGroup>
              </Col>

              <Col xl="3" lg="6" md="12" className="payments-total">
                <FormGroup>
                  <Label htmlFor="payments.total">
                    <FormattedMessage id="payments.total" defaultMessage="To payoff" />
                  </Label>
                  <InputGroup id="payments-total">
                    <Input
                      bsSize="sm"
                      onChange={(e) =>
                        onToPayoutChange(
                          e.target.value,
                          rules,
                          selectedCurrency,
                          toCurrency,
                          rates,
                          data.purse,
                        )
                      }
                      value={data.amountToPayout}
                      id="payments.total"
                    />

                    <InputGroupAddon addonType="append" id="currency-sign">
                      <InputGroupText>{currencyToSign(toCurrency)}</InputGroupText>
                    </InputGroupAddon>
                    {isCurrencyConverting && renderConverToCurrencyTooltip()}
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>

            <Row className="text-center">
              <Col>
                <Button
                  color="primary"
                  className="payments-order-btn"
                  size="lg"
                  disabled={
                    !data.amount ||
                    data.amount <= 0 ||
                    data.purse === null ||
                    loading ||
                    !selected ||
                    isUserBlocked ||
                    isSlaveAndNotInMember
                  }
                  tabIndex="4"
                >
                  <FormattedMessage id="payments.add_payment" defaultMessage="Add payment" />
                </Button>

                <Hold2BalanceOrder theme={3} showAlert={showAlert} size="md" />
              </Col>
            </Row>

            <SMSNotificationsModal
              transport={transport}
              authType={authType}
              sessionId={sessionId}
              validTill={validTill}
              isOpen={smsConfirmModalShow}
              toggleModal={toggleModal}
              onSubmit={onSubmit}
              error={error}
              status={status}
            />
          </Form>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default WithAlert(PaymentsOrdersForm);
